import { useParams } from "react-router-dom";
import PurchaseHeader from "./purchaseComponents/PurchaseHeader";
import BreadcrumbPurchase from "./purchaseComponents/BreadcrumbPurchase";
import { FaChevronDown } from "react-icons/fa";
import CardProduct from "./purchaseComponents/CardProduct";
import EmptyList from "../../ui/EmptyList";
import ModalFilter from "./purchaseComponents/ModalFilter";
import { useEffect, useMemo, useRef, useState } from "react";
import ModalFilterPrincipal from "./purchaseComponents/ModalFilterPrincipal";
import ModalFilterCategory from "./purchaseComponents/ModalFilterCategory";
import ModalSortProduct from "./purchaseComponents/ModalSortProduct";
import { useQuery } from "@tanstack/react-query";
import { getPrincipalPbf } from "../../../services/purchaseApi";
import { CircularProgress } from "@mui/material";
import PurchasePagination from "./purchaseComponents/PurchasePagination";
import { useProductListQueryPbf } from "../../hooks/purchaseHook/useProductListQueryPbf";

const PurchaseProductList = () => {
  const { listType } = useParams();
  const { principalId } = useParams();
  const searchRef = useRef();

  const [reqBody, setReqBody] = useState({
    search: "",
    offset: 1,
    limit: listType ? 50 : 10,
    label_ids: [],
    category_ids: [], // not currently used
    principal_ids: [],
    offer_type: listType
      ? listType === "special-offer"
        ? "special_offer"
        : listType === "recent-search"
          ? "search_by_user"
          : listType === "most-search"
            ? "most_bought"
            : ""
      : "",
    order_by: "created_desc",
  });
  const [openFilter, setOpenFilter] = useState(false);
  const [openFilterPrincipal, setOpenFilterPrincipal] = useState(false);
  const [openFilterCategory, setOpenFilterCategory] = useState(false);
  const [openSort, setOpenSort] = useState(false);
  const [prevList, setPrevList] = useState([]);

  const getTitle = () => {
    return listType
      ? listType === "all"
        ? "Semua Produk"
        : listType === "special-offer"
          ? "Penawaran Special"
          : listType === "recent-search"
            ? "Berdasarkan Pencarianmu"
            : listType === "most-search"
              ? "Paling Banyak Dicari"
              : listType.includes("keyword=")
                ? listType.split("=")[1]
                : ""
      : "";
  };

  const { data: dataPrincipal } = useQuery({
    queryKey: ["rank-principle", principalId],
    queryFn: () => getPrincipalPbf(),
    refetchOnWindowFocus: false,
    enabled: principalId !== undefined,
    keepPreviousData: true,
  });

  const {
    data: dataList,
    isFetching: isLoading,
    refetch: refetchList,
  } = useProductListQueryPbf(reqBody);

  const currentPrincipal = useMemo(() => {
    if (!principalId) return;
    if (principalId && dataPrincipal) {
      return dataPrincipal.find(
        (principal) => principal.principal_id === Number(principalId),
      );
    }
  }, [dataPrincipal]);

  useEffect(() => {
    if (principalId)
      setReqBody((prevVal) => ({
        ...prevVal,
        principal_ids: [Number(principalId)],
      }));
  }, [principalId]);

  useEffect(() => {
    if (!listType) return;
    else if (listType?.includes("keyword=")) {
      setReqBody((prevVal) => ({
        ...prevVal,
        search: listType.split("=")[1],
      }));
    }
  }, [listType]);

  // for home purchase screen
  useEffect(() => {
    if (!listType) refetchList();
  }, []);

  useEffect(() => {
    if (dataList)
      console.log(
        dataList,
        Math.ceil(dataList.total_data / reqBody.limit),
        reqBody.offset,
      );
  }, [dataList]);

  return (
    <div className="text-[12px] text-[#2C3E5D]">
      <PurchaseHeader searchRef={searchRef} />

      <div className={`${listType ? "mt-[70px]" : ""}`}>
        {listType ? (
          <div className="px-3 pt-2 mb-4">
            <BreadcrumbPurchase
              principalName={
                principalId && currentPrincipal
                  ? currentPrincipal.principal_name_alias
                  : ""
              }
            />
          </div>
        ) : null}

        <div className="px-3 mb-4">
          {listType ? (
            principalId && currentPrincipal ? (
              <div className="flex gap-4 items-center">
                <img
                  src={currentPrincipal.logo}
                  className="w-[100px] h-[100px] rounded-full"
                />
                <div className="w-full">
                  <p className="text-[24px] font-semibold">
                    {currentPrincipal.principal_name_alias}
                  </p>
                  {dataList ? <p>{dataList.count} Produk</p> : null}
                </div>
              </div>
            ) : (
              <>
                <p className="text-[24px] font-semibold">{getTitle()}</p>
                {listType?.includes("keyword=") ? (
                  <p>
                    Menampilkan {dataList?.count} hasil pencarian untuk "
                    <b>{getTitle()}</b>"
                  </p>
                ) : null}
              </>
            )
          ) : null}
        </div>

        {listType ? (
          <div className="px-3 mb-4 block md:flex items-center justify-between overflow-y-auto">
            <div className="flex items-center gap-2">
              {principalId ? null : (
                <div
                  className={`border-2 rounded-md flex items-center justify-between gap-2 md:gap-4 p-2 cursor-pointer ${
                    reqBody.label_ids.length === 0 &&
                    reqBody.principal_ids.length === 0
                      ? "hover:bg-gray-100 bg-white"
                      : "bg-[#F1FAF0] text-[#6F955B] border-[#6F955B]"
                  }`}
                  onClick={() => setOpenFilter(true)}
                >
                  <p>Filter</p>
                  <div className="flex items-center gap-2">
                    <div
                      className={`${
                        reqBody.label_ids.length === 0 &&
                        reqBody.principal_ids.length === 0
                          ? ""
                          : "bg-[#94C679]"
                      } text-white p-2 rounded-full flex items-center justify-center w-[18px] h-[18px] text-[10px]`}
                    >
                      {reqBody.label_ids.length === 0 &&
                      reqBody.principal_ids.length === 0
                        ? ""
                        : reqBody.label_ids.length + reqBody.principal_ids.length}
                    </div>
                    <FaChevronDown />
                  </div>
                </div>
              )}
              <div
                className={`border-2 rounded-md flex items-center justify-between gap-2 md:gap-4 p-2 cursor-pointer ${
                  reqBody.label_ids.length === 0
                    ? "hover:bg-gray-100 bg-white"
                    : "bg-[#F1FAF0] text-[#6F955B] border-[#6F955B]"
                }`}
                onClick={() => setOpenFilterCategory(true)}
              >
                <p>Golongan</p>
                <div className="flex items-center gap-2">
                  <div
                    className={`${
                      reqBody.label_ids.length === 0 ? "" : "bg-[#94C679]"
                    } text-white p-2 rounded-full flex items-center justify-center w-[18px] h-[18px] text-[10px]`}
                  >
                    {reqBody.label_ids.length === 0
                      ? ""
                      : reqBody.label_ids.length}
                  </div>
                  <FaChevronDown />
                </div>
              </div>
              {principalId ? null : (
                <div
                  className={`border-2 rounded-md flex items-center justify-between gap-2 md:gap-4 p-2 cursor-pointer ${
                    reqBody.principal_ids.length === 0
                      ? "hover:bg-gray-100 bg-white"
                      : "bg-[#F1FAF0] text-[#6F955B] border-[#6F955B]"
                  }`}
                  onClick={() => setOpenFilterPrincipal(true)}
                >
                  <p>Principal</p>
                  <div className="flex items-center gap-2">
                    <div
                      className={`${
                        reqBody.principal_ids.length === 0 ? "" : "bg-[#94C679]"
                      } text-white p-2 rounded-full flex items-center justify-center w-[18px] h-[18px] text-[10px]`}
                    >
                      {reqBody.principal_ids.length === 0
                        ? ""
                        : reqBody.principal_ids.length}
                    </div>
                    <FaChevronDown />
                  </div>
                </div>
              )}
              {principalId ? (
                reqBody.label_ids.length > 0
              ) : reqBody.label_ids.length > 0 ||
                reqBody.principal_ids.length > 0 ? (
                <p
                  className="font-semibold hover:underline cursor-pointer"
                  onClick={() =>
                    setReqBody((prevVal) => ({
                      ...prevVal,
                      label_ids: [],
                      principal_ids: principalId ? [Number(principalId)] : [],
                    }))
                  }
                >
                  Reset
                </p>
              ) : null}
            </div>
            <div className="flex items-center gap-2 mt-2 md:mt-0">
              <p>Urutkan: </p>
              <div
                className={`${
                  true
                    ? "border-2 rounded-md flex items-center justify-between gap-2 md:gap-4 p-2 cursor-pointer hover:bg-gray-100 bg-white"
                    : ""
                }`}
                onClick={() => setOpenSort(true)}
              >
                <p className="whitespace-nowrap">
                  {
                    [
                      {
                        id: "price_asc",
                        name: "Harga Terendah",
                      },
                      {
                        id: "price_desc",
                        name: "Harga Tertinggi",
                      },
                      { id: "name_asc", name: "Nama Produk A-Z" },
                      { id: "name_desc", name: "Nama Produk Z-A" },
                      { id: "created_desc", name: "Terbaru" },
                    ].find((item) => item.id === reqBody.order_by)?.name
                  }
                </p>
                <FaChevronDown />
              </div>
            </div>
          </div>
        ) : null}

        {dataList &&
        !isLoading &&
        // (dataList.product || dataList.so) &&
        dataList.data &&
        dataList.total_data > 0 ? (
          <div className="px-3 mb-4 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 items-stretch">
            {(listType ? dataList.data : [...prevList, ...dataList.data]).map(
              (item, i) => {
                return (
                  <div className="w-full relative h-full">
                    <CardProduct
                      product={item}
                      type={item.product_so_id ? 2 : 1}
                    />
                  </div>
                );
              },
            )}
          </div>
        ) : (
          <div className="px-3 mb-4">
            {isLoading ? (
              <CircularProgress size={20} />
            ) : (
              <EmptyList
                message={
                  <div className="text-center">
                    <p className="text-xl align-center mt-8 mb-1">
                      Tidak ada hasil yang sesuai
                    </p>
                    <p className="text-[12px] mb-8">
                      Ubah kata kuncimu untuk menemukan produk lainnya
                    </p>
                    <button
                      type="button"
                      className="text-white bg-[#94C679] hover:bg-gray-300 rounded-md w-fit py-2.5 px-4 text-[14px] disabled:bg-gray-300"
                      onClick={() => {
                        if (searchRef.current) {
                          searchRef.current.focus();
                        }
                      }}
                    >
                      Ubah Pencarian
                    </button>
                  </div>
                }
              />
            )}
          </div>
        )}
      </div>

      {dataList && !isLoading && dataList.total_data > 0 ? (
        listType ? (
          <div className="px-4 mb-4">
            <PurchasePagination
              offset={reqBody.offset}
              limit={reqBody.limit}
              setOffset={(e) =>
                setReqBody((prevVal) => ({ ...prevVal, offset: e }))
              }
              setLimit={(e) => {
                setReqBody((prevVal) => ({ ...prevVal, limit: e }));
              }}
              total={dataList.total_data}
            />
          </div>
        ) : Math.ceil(dataList.total_data / reqBody.limit) ===
          reqBody.offset ? (
          <p className="w-full text-center cursor-default text-gray-500">
            Tidak ada produk lagi
          </p>
        ) : (
          <button
            type="button"
            className="border-2 rounded-md p-2 bg-[#F1FAF0] border-[#6F955B] text-[#6F955B] w-full hover:bg-gray-200 disabled:border-none disabled:bg-gray-300 disabled:text-white"
            disabled={isLoading}
            onClick={() => {
              setPrevList(dataList.data);
              setReqBody((prevVal) => ({
                ...prevVal,
                offset: prevVal.offset + 1,
              }));
            }}
          >
            {isLoading ? (
              <CircularProgress size={10} />
            ) : (
              "Muat Lebih Banyak Produk"
            )}
          </button>
        )
      ) : null}

      <ModalFilter
        open={openFilter}
        setOpen={setOpenFilter}
        reqBody={reqBody}
        setReqBody={setReqBody}
      />
      <ModalFilterPrincipal
        open={openFilterPrincipal}
        setOpen={setOpenFilterPrincipal}
        reqBody={reqBody}
        setReqBody={setReqBody}
      />
      <ModalFilterCategory
        open={openFilterCategory}
        setOpen={setOpenFilterCategory}
        reqBody={reqBody}
        setReqBody={setReqBody}
      />
      <ModalSortProduct
        open={openSort}
        setOpen={setOpenSort}
        reqBody={reqBody}
        setReqBody={setReqBody}
      />
    </div>
  );
};

export default PurchaseProductList;
